import {useEffect, useState} from 'react';
import {getClientConfig} from '../services/ClientConfigService';
import {MAX_DIRECT_VIDEO_UPLOAD_MB, MAX_VIDEO_UPLOAD_MB} from '../utils/videoUtils';

/**
 * The largest video this environment can actually take, in MB.
 *
 * <p>The two upload paths have very different ceilings — the direct-to-S3 path is bounded by the
 * server's own cap, while the legacy path streams through the API and is bounded by its far smaller
 * multipart limit. A picker that advertises the wrong one either turns users away from files that
 * would have uploaded fine, or accepts a file that fails deep in the request with no useful message.
 *
 * <p>Starts at the smaller limit and widens once the environment answers, so the window before the
 * config arrives errs towards a file that is certain to work.
 */
export function useMaxVideoUploadMb() {
    const [maxMb, setMaxMb] = useState(MAX_VIDEO_UPLOAD_MB);

    useEffect(() => {
        let active = true;
        getClientConfig().then(({directVideoUploadEnabled}) => {
            if (active && directVideoUploadEnabled) {
                setMaxMb(MAX_DIRECT_VIDEO_UPLOAD_MB);
            }
        });
        return () => {
            active = false;
        };
    }, []);

    return maxMb;
}

export default useMaxVideoUploadMb;
